const SEO = [
	{
		page: "home",
		description:
			"Emmanuel Kyeremeh - Software Engineer and Data Analyst with expertise in React.js, Next.js, Node.js, Express.js, FastAPI, Flask, and MongoDB. Building innovative web applications and machine learning solutions.",
		keywords: ["Emmanuel Kyeremeh", "Software Engineer", "Data Analyst", "React.js", "Node.js", "MongoDB", "Machine Learning", "Web Development", "Ghana"],
	},

	{
		page: "about",
		description:
			"Learn more about Emmanuel Kyeremeh, a Software Engineer and Data Analyst based in Accra, Ghana. Discover his journey in building software and data analysis projects.",
		keywords: ["Emmanuel Kyeremeh", "About", "Software Engineer", "Data Analyst", "Accra Ghana", "Portfolio", "Developer"],
	},

	{
		page: "projects",
		description:
			"Explore Emmanuel Kyeremeh's portfolio of innovative projects including Chordara, Mindflow, Profina, ProposeAI, Velocify, and more. Open-source projects and web applications.",
		keywords: ["Emmanuel Kyeremeh", "Projects", "Portfolio", "Chordara", "Mindflow", "Profina", "ProposeAI", "Velocify", "Web Applications", "Open Source"],
	},

	{
		page: "contact",
		description:
			"Get in touch with Emmanuel Kyeremeh for collaboration opportunities, project discussions, or any inquiries. Always open to new ideas and opportunities.",
		keywords: ["Emmanuel Kyeremeh", "Contact", "Collaboration", "Software Engineer", "Data Analyst", "Ghana", "Email"],
	},
];

export default SEO;
